import React from 'react';
import DownloadButton from '../../components/downloadButton/DownloadButton';
import styles from './Downloads.module.css';

const Downloads = ({ hasReport, reportLink, highlightLink }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>附件</h2>
      <div className={styles.buttons}>
        {hasReport && <DownloadButton text="收支報告" link={reportLink} />}
        <DownloadButton text="行程精華錄" link={highlightLink} />
      </div>
    </div>
  );
};

export default Downloads;
